import React, { useState, useEffect } from "react";
import * as Styled from "../../../CompanyForm.styled";
import * as MUIStyled from "../../../MUIStyled.js";
import CheckboxWithLabel from "../../elements/CheckBoxWithLabel/CheckBoxWithLabel";
import { useNavigate } from "react-router-dom";
import { DefaultLayout } from "../../common/Layout/DefaultLayout";
import {
    getTermsAndCondition,
    postTermsAndCondition,
} from "../../../config/fetchAPI";
import ProgressBarStepper from "../../elements/ProgressBar/ProgressBar";
import {
    BackButton,
    ButtonPurpleNext,
} from "../../elements/Buttons/Buttons.js";
import Loading from "../../elements/Loading/Loading.js";

const currentStep = 4;
const totalSteps = 6;

export const PayrollTermAndConditionPage = () => {
    const [termsConditions, setTermsConditions] = useState([]);

    const [hasErrorOccurred, setHasErrorOccurred] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();

    const associations = sessionStorage.getItem("associations");

    useEffect(() => {
        fetchData();
        // eslint-disable-next-line
    }, []);

    const fetchData = async () => {
        try {
            const [termsResponse] = await Promise.all([getTermsAndCondition()]);

            // matching content from association with terms checkbox by id
            const allTerms = JSON.parse(associations).terms || [];
            const termsContent = allTerms.filter((term) =>
                [1, 2, 3, 5].includes(term.ID)
            );

            const mergedTerms = termsContent.map((termContent) => {
                const termStatus = termsResponse.find(
                    (t) => t.id === termContent.ID
                );
                return {
                    id: termContent.ID,
                    content: termContent.Content,
                    accepted: termStatus?.accepted || false,
                    required: termContent.Required,
                    validator: termContent.validator,
                };
            });

            setTermsConditions(mergedTerms);
        } catch (err) {
            console.error("Error loading cached fields:", err);
        } finally {
            setIsLoading(false);
        }
    };

    const handlePostTermsAndCondition = async () => {
        try {
            // Remove 'content' field before posting (API only accepts id and accepted)
            const termsToPost = termsConditions.map(({ id, accepted }) => ({
                id,
                accepted,
            }));
            await postTermsAndCondition(termsToPost);
        } catch (error) {
            console.error("Error loading cached fields:", error);
        }
    };

    const handleCheckboxChange = (key, isChecked) => {
        setTermsConditions((prev) =>
            prev.map((item) =>
                item.id === key ? { ...item, accepted: isChecked } : item
            )
        );
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setHasErrorOccurred(false);

        // Check if any required term is not accepted
        const hasUnacceptedRequiredTerms = termsConditions.some(
            (item) => item.required && !item.accepted
        );

        if (hasUnacceptedRequiredTerms) {
            setErrorMessage(
                "Please check all the required terms and conditions."
            );
            setHasErrorOccurred(true);
            return;
        }

        handlePostTermsAndCondition();
        navigate("/paymentInfo");
    };

    const handleBack = () => {
        navigate("/contactDetail");
    };

    return (
        <DefaultLayout currentStep={currentStep}>
            {isLoading ? (
                <Loading />
            ) : (
                <Styled.PayrolMainContainer>
                    <MUIStyled.CustomContainer>
                        <Styled.MainTitleArrowWrapper
                            style={{ width: "100%", marginBottom: "40px" }}>
                            <BackButton
                                onClick={handleBack}
                                sx={{ marginLeft: "0" }}
                            />
                            <Styled.MainTitle style={{ margin: "8px 0 0 0" }}>
                                Payroll deductions, invoicing &<br />
                                employer obligations
                            </Styled.MainTitle>
                        </Styled.MainTitleArrowWrapper>
                    </MUIStyled.CustomContainer>

                    <MUIStyled.CustomContainer>
                        <Styled.BodyText style={{ marginBottom: "40px" }}>
                            Please read the below information carefully and tick
                            each section confirming your acceptance of these
                            obligations. A copy of this information will be
                            provided to you upon submission of this form.
                        </Styled.BodyText>
                    </MUIStyled.CustomContainer>

                    <form onSubmit={handleSubmit}>
                        <Styled.TermsConditionContainer>
                            {termsConditions.map((item) => {
                                const label = item.required
                                    ? "*Required"
                                    : "Optional";

                                return (
                                    <Styled.PayrollTandCList key={item.id}>
                                        <div
                                            style={{
                                                width: "100%",
                                                marginBottom: "8px",
                                                textAlign: "right",
                                            }}>
                                            <span
                                                style={{
                                                    fontSize: "14px",
                                                    fontWeight: "600",
                                                    color: item.required
                                                        ? "#d32f2f"
                                                        : "#666",
                                                    fontStyle: item.required
                                                        ? "normal"
                                                        : "italic",
                                                }}>
                                                {label}
                                            </span>
                                        </div>
                                        <Styled.BodyText
                                            style={{
                                                width: "100%",
                                                textAlign: "left",
                                                margin: "0 30px 0 0",
                                            }}>
                                            {item.content}
                                        </Styled.BodyText>

                                        <CheckboxWithLabel
                                            checked={item.accepted || false}
                                            onChange={(event) =>
                                                handleCheckboxChange(
                                                    item.id,
                                                    event.target.checked
                                                )
                                            }
                                            sx={{
                                                width: "100%",
                                                textAlign: "left",
                                                margin: "10px 0 0 -12px",
                                            }}
                                            label={
                                                <Styled.CheckboxLabel>
                                                    I accept
                                                </Styled.CheckboxLabel>
                                            }
                                        />
                                    </Styled.PayrollTandCList>
                                );
                            })}
                        </Styled.TermsConditionContainer>

                        {hasErrorOccurred && (
                            <MUIStyled.CustomAlert severity="error">
                                {errorMessage}
                            </MUIStyled.CustomAlert>
                        )}

                        <MUIStyled.CustomGrid
                            container
                            justifyContent={{ xs: "center", sm: "flex-end" }}
                            alignSelf={"flex-end"}
                            marginRight={"25px"}>
                            <ButtonPurpleNext
                                type="submit"
                                style={{ marginTop: "30px" }}>
                                {isLoading ? (
                                    <MUIStyled.CustomCircularProgress
                                        size={24}
                                    />
                                ) : (
                                    "Next"
                                )}
                            </ButtonPurpleNext>
                        </MUIStyled.CustomGrid>
                    </form>

                    <Styled.ProgressBarContainerWrapper>
                        {currentStep <= totalSteps && (
                            <ProgressBarStepper
                                currentStep={currentStep}
                                totalSteps={totalSteps}
                            />
                        )}
                    </Styled.ProgressBarContainerWrapper>
                </Styled.PayrolMainContainer>
            )}
        </DefaultLayout>
    );
};
